import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { AppService, BASE_URL_API } from '../../../app.service';
import { Observable } from 'rxjs';
import { ResultModel } from '../../model/result.model';

@Injectable({
  providedIn: 'root'
})
export class StudentsService extends AppService {

  constructor(http: HttpClient) {
    super(http);
  }

  GetOne<T>(pi_stu_bi_id: number): Observable<any> {
    this.endpoint = `${BASE_URL_API}/students/`+ pi_stu_bi_id;
    return this.get(this.endpoint);
  }
  GetAll<T>(pi_per_in_document_type: number,pi_per_vc_document_number: string,pi_stu_in_status: number): Observable<any> {
    if(pi_per_vc_document_number==null){
      pi_per_vc_document_number = ' ';
    }
    if(pi_per_vc_document_number==''){
      pi_per_vc_document_number = ' ';
    }
    
    this.endpoint = `${BASE_URL_API}/students/`+pi_per_in_document_type+'/'+pi_per_vc_document_number+'/'+pi_stu_in_status;
    return this.get(this.endpoint);
  }
  Insert<T>(datos:any):Observable<Object>{
    this.endpoint = `${BASE_URL_API}/students`;
    return this.post(this.endpoint, datos);
  }
  Update<T>(datos:any):Observable<Object>{
    this.endpoint = `${BASE_URL_API}/students`;
    return this.put(this.endpoint, datos);
  }
  Delete<T>(stu_bi_id:number):Observable<Object>{
    this.endpoint = `${BASE_URL_API}/students/${stu_bi_id}`;
    return this.delete(this.endpoint);
  }

  GetAssign<T>(cou_in_id: number): Observable<any> {
     
    this.endpoint = `${BASE_URL_API}/students-courses-assign/`+cou_in_id;
    return this.get(this.endpoint);
  }

  Update_Status<T>(datos:any):Observable<Object>{
    this.endpoint = `${BASE_URL_API}/students`;
    return this.patch(this.endpoint,datos);
  }
}
